'use client';

import showApplicationStatus from '@coolblue-development/ga4-events/triggers/VacancyApplicationSubmit/showApplicationStatusTrigger';
import showApplicationStatusTrigger from '@coolblue-development/ga4-events/triggers/VacancyApplicationSubmit/showApplicationStatusTrigger';
import { TrackImmediate } from '@coolblue-development/next-analytics/client';
import React from 'react';

import { GenericSuccessMessage } from './GenericSuccessMessage';
import { SpotlerSuccessMessage } from './SpotlerSuccessMessage';

type Props = {
  isSpotlerMessage: boolean;
};

export const SuccessMessage = ({ isSpotlerMessage }: Props) => {
  return (
    <>
      <TrackImmediate
        trigger={showApplicationStatus({
          sub_feature: 'successful_application'
        })}
      />
      {isSpotlerMessage ? (
        <>
          <TrackImmediate
            trigger={showApplicationStatusTrigger({
              sub_feature: 'follow_up_success'
            })}
          />
          <SpotlerSuccessMessage />
        </>
      ) : (
        <GenericSuccessMessage />
      )}
    </>
  );
};
